<script lang="ts">
  import * as _ from "lodash";
  import { createEventDispatcher } from "svelte";
  import type { QuickOrderListParams } from "@shared/types/QuickOrderList";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import { params } from "@roxi/routify";
  import { onMount } from "svelte";

  export let filters: QuickOrderListParams;
  export let setLoading: Function;

  let searchValue = filters.search;

  const dispatch = createEventDispatcher();

  const handleInput = _.debounce(() => {
    filters.page = 1;
    filters.search = searchValue;
    setLoading();
    dispatch("selectFilter", { filters });
  }, 600);

  onMount(function () {
    document.getElementById("list-search-input").addEventListener("search", handleInput);
  });

  let searchKey = "";
  $: {
    if ($params.listId) {
      searchKey = `list-${$params.listId}`;
    } else if ($params.smart_filter_distributor) {
      searchKey = `smartfilter-${$params.smart_filter_distributor}`;
    } else {
      searchKey = "my_saved_products";
    }
  }

  $: {
    if (searchKey) {
      searchValue = "";
      handleInput.cancel();
    }
  }

</script>

<input
  bind:value={searchValue}
  on:keyup={handleInput}
  type="search"
  id="list-search-input"
  class="fizz-input-search fizz-flex-item fizz-inline"
  data-testId="qol-search"
  class:fizz-inline={$LayoutStore.isMobile}
  placeholder="Quickly find an item on your list"
  style="min-width:246px;"
/>
